import { createFileRoute } from '@tanstack/react-router';
import { Section } from '@cartcloser/ui/marketing';

export const Route = createFileRoute('/terms')({
  component: TermsPage,
});

function TermsPage() {
  return (
    <Section title="Terms of Service">
      <div className="mx-auto max-w-2xl space-y-4 text-sm text-muted-foreground">
        <p>
          This is a placeholder terms of service. By using CartCloser you agree to use it for lawful
          commerce and to provide accurate product data.
        </p>
        <p>
          Service is provided as-is during early access. Replace this page with your finalised terms
          before launch.
        </p>
      </div>
    </Section>
  );
}
